import { Spinner } from '@acorns/web-components'
import styled from 'styled-components'

import Layout, { Container } from 'components/Layout/Layout'
import Separator from 'components/Separator'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const ActionWrapper = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: white;
    bottom: 0;
    left: 0;
    padding: 0 20px 20px 20px;
    position: fixed;
    width: 100%;
  }
`
export const StyledLayout = styled(Layout)`
  padding: 10px 0px 14px 0px;

  ${Container} {
    @media (max-width: 499px) {
      padding: 0px 10px;
    }
    @media (min-width: 500px) {
      padding: 0px 30px 8px;
    }
  }

  @media (min-width: 500px) {
    padding: 10px 0px 62px;
  }
`

export const PageContainer = styled.div`
  height: 100vh;
`

export const LayoutContents = styled.div`
  position: relative;
  height: calc(100vh - 172px);
  min-height: 430px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 30px 0 30px;

  @media (min-width: 500px) {
    height: calc(100vh - 358px);
  }

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    height: calc(100vh - 468px);
  }
`

export const ImageAndTextContainer = styled.div`
  margin: auto 0px;
`

export const ImageContainer = styled.div`
  height: 140px;
  margin: 0 auto 30px;
  max-width: 235px;
`

export const DownloadNowImage = styled.img`
  width: 100%;
`

export const TextContainer = styled.div`
  text-align: center;
  margin-bottom: auto;
`

export const Title = styled(Heading2)`
  text-align: center;
  font-size: 22px;
  line-height: 30px;
`

export const Message = styled(Body)`
  margin: 10px auto 0px;
  font-size: 14px;
  line-height: 22px;
  max-width: 315px;
`

export const TabletFooterTextContainer = styled.div`
  text-align: center;
`

export const DownloadAppButtonContainer = styled.div`
  height: 44px;
  max-width: 335px;
  margin: 0px auto;
  line-height: 0px;
  position: sticky; 
  bottom 34px;
  @media (min-width: 500px) {
    max-width: 220px;
    margin: 14px auto 0px;
  }
`

export const StyledSeparator = styled(Separator)`
  display: none;

  @media (min-width: 501px) {
    display: block;
    margin-top: 10px;
  }
`

export const DownloadAppButton = styled.a`
  display: inline-block;
  line-height: 0px;
`

export const DownloadAppButtonImage = styled.img`
  width: 100%;
`

export const StyledSpinner = styled(Spinner)`
  margin-bottom: 14px;
`
